import React from 'react';
import { Toolbar } from './Toolbar.jsx';
import { Canvas } from './Canvas.jsx';
import { Inspector } from './Inspector.jsx';

/**
 * Shell
 *
 * The outer layout of the block editor:
 *   [Toolbar]
 *   [Canvas]  |  [Inspector panel]
 *
 * Props:
 *   title   {string}
 *   onSave  {Function}
 *   onClose {Function}
 */
export function Shell({ title, onSave, onClose }) {
  return (
    <div
      className="editor-shell d-flex flex-column"
      style={{ height: '100%', overflow: 'hidden' }}
    >
      <Toolbar title={title} onSave={onSave} onClose={onClose} />

      <div className="d-flex flex-row" style={{ flex: 1, overflow: 'hidden' }}>
        {/* Main canvas */}
        <Canvas style={{ flex: 1 }} />

        {/* Right inspector panel */}
        <div
          className="editor-inspector-panel border-start"
          style={{
            width: 260,
            flexShrink: 0,
            overflowY: 'auto',
            background: '#f8f9fa',
          }}
        >
          <Inspector />
        </div>
      </div>
    </div>
  );
}
